<template src="./surveysPage.html"></template>

<script>
import surveysEndpoints from '../surveys.endpoints';
import dataTableMixin from '../../../js/dataTableMixin.js';

export default {
    name: 'surveys-page',
    mixins: [dataTableMixin],
    data() {
        return {
            dto: {
                SchoolYear: '',
                SponsorID: -1,
                IntermediaryID: -1,
                InstitutionID: -1,
                StatusType: '',
                PageNumber: 1,
                PageRows: 100,
                SortByColumn: 'SchoolYearF',
                SortDirection: 'asc'
            },
            dropdownFields: {
                text: 'Text',
                value: 'Value'
            },
            schoolYearOptions: [],
            schoolYearFields: {
                text: 'SchoolYearF',
                value: 'SchoolYear',
            },
            statusOptions: [],
            surveysTableActions: [
                {
                    text: 'Edit Survey',
                },
                {
                    text: 'Manage Survey',
                },
            ],
            surveysTableItems: [],
            surveysTableSortBy: {
                columns: [{ field: 'SchoolYearF', direction: 'Ascending' }],
            },
        };
    },
    computed: {
        permissions() {
            return this.$store.state.PermissionsModule.surveyPermissions;
        },
        customizationPermissions() {
            return this.$store.state.PermissionsModule.intermediaryCustomizePermissions;
        },
        surveysTableColumns() { 
            let columns = [
                {
                    type: 'iconTemplate',
                    iconName: 'ellipsis',
                    ellipsisActions: this.surveysTableActions,
                    iconOnClick: this.surveysTableActionOnClick,
                    width: '55px',
                    allowSorting: false
                },
                {
                    key: 'InstitutionName',
                    label: 'Institution',
                    width: '200px',
                    allowSorting: true
                },
                {
                    key: 'SponsorNames',
                    label: 'Programs',
                    clipMode: 'EllipsisWithTooltip',
                    allowSorting: true,
                    formatter: (column, data) => {
                        return data.SponsorNames.join(', ');
                    },
                },
                {
                    key: 'PrimaryIntermediaryName',
                    label: 'Primary Intermediary',
                    allowSorting: true
                },
                {
                    key: 'AdditionalIntermediaryNames',
                    label: 'Addtl Intermediaries',
                    clipMode: 'EllipsisWithTooltip',
                    allowSorting: true,
                    formatter: (column, data) => {
                        return data.AdditionalIntermediaryNames.join(', ');
                    },
                },
                {
                    key: 'SchoolYearF',
                    label: 'School Year',
                    width: '110px',
                    allowSorting: true
                },
                {
                    key: 'StartDateF',
                    label: 'Start Date',
                    width: '110px',
                    allowSorting: true
                },
                {
                    key: 'EndDateF',
                    label: 'End Date',
                    width: '110px',
                    allowSorting: true
                },
                {
                    key: 'Status',
                    label: 'Status',
                    width: '110px',
                    allowSorting: true
                },
                {
                    key: 'NumberOfResponses',
                    label: 'Responses',
                    width: '100px',
                    headerTextAlign: 'right',
                    textAlign: 'right',
                    allowSorting: true
                },
            ];

            if (!this.permissions.CanUpdate) {
                columns.shift();
            }

            return columns;
        }
    },
    methods: {
        surveysTableRowOnClick(args) {
            this.selectedRow = args;
        },
        surveysTableActionOnClick(args) {
            if (args.item.text === 'Edit Survey') {
                this.update();
            } else if (args.item.text === 'Manage Survey') {
                this.$router.push({name: 'survey-details', query: {surveyID: this.selectedRow.rowData.SurveyID, institution: this.selectedRow.rowData.InstitutionName}});
            }
        },
        dropdownChanged(args) {
            if (args.isInteracted) {
                this.getAll();
            }
        },
        getAll() {
            surveysEndpoints.getAll(this.dto)
                    .then((response) => {
                        this.surveysTableItems = {
                            result: response.Rows,
                            count: response.NumberOfRecords,
                        };
                    });
        },
        create() {
            if (this.permissions.CanCreate) {
                let modalData = {
                    mode: 'add',
                    dto: {
                        InstitutionID: -1,
                        StartDate: null,
                        EndDate: null,
                        TransformationTeamEnabled: true,
                        StudentSuccessCommunityEnabled: true,
                    },
                    callback: this.getAll,
                };
    
                DMUtils.openApplicationModal('surveysEditModal', modalData);
            }
        },
        update() {
            if (this.permissions.CanUpdate) {
                let modalData = {
                    mode: 'edit',
                    dto: {},
                    callback: this.getAll,
                };
    
                surveysEndpoints.getByID(this.selectedRow.rowData.SurveyID)
                .then((response) => {
                    modalData.dto = response;
    
                    DMUtils.openApplicationModal('surveysEditModal', modalData);
                });
            }
        },
        customize() {
            DMUtils.openApplicationModal('customizeSurveyModal');
        },
        getAllDropdownOptions() {
            return this.$store.dispatch('getProgramOptions')
                .then(() => {
                    return this.$store.dispatch('getIntermediaryOptions')
                })
                .then(() => {
                    return this.$store.dispatch('getInstitutionOptions')
                })
                .then(() => {
                    return surveysEndpoints.getSurveyStatuses()
                })
                .then((response) => {
                    this.statusOptions = response;
                })
        },
    },
    created() {
        this.getAllDropdownOptions()
            .then(() => {
                surveysEndpoints.getSchoolYears()
                    .then((response) => {
                        this.schoolYearOptions = response;
                    })
                    .then(() => {
                        this.dto.SchoolYear = this.schoolYearOptions[0].SchoolYear;
                        this.getAll();
                    });
            })

    },
};
</script>
